/**
 * GEOGRAPHY API — Wrapper REST per Country e Region (read-only).
 *
 * Contratto backend (rest-openapi.yaml + verifica empirica via curl):
 *   - GET /countries                       -> Page<Country>
 *   - GET /country/{countryId}/regions     -> Page<Region>
 *
 * Lo schema OpenAPI dichiara `type: array` ma la response runtime di
 * Liferay REST Builder wrappa SEMPRE in Page (`{actions, facets, items,
 * ...}`). Estraiamo `.items` qui per dare al chiamante un array piatto.
 *
 * Niente CRUD: i dati di Country/Region sono gestiti da Liferay Portal
 * core, esposti read-only via questi 2 endpoint custom CRM.
 */

import type { Page } from '@crm/shared';
import { httpClient } from '../../api/httpClient';
import type { Country, Region } from './geographyTypes';

export const geographyApi = {
  fetchCountries: (): Promise<Country[]> =>
    httpClient.get<Page<Country>>('/countries').then((r) => r.data.items),

  fetchRegionsByCountry: (countryId: number): Promise<Region[]> =>
    httpClient.get<Page<Region>>(`/country/${countryId}/regions`).then((r) => r.data.items),
};
